var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M15,28.125A13.125,13.125,0,1,0,1.875,15,13.125,13.125,0,0,0,15,28.125ZM15,30A15,15,0,1,0,0,15,15,15,0,0,0,15,30Z",
    fill: "#329bc9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M20.093,14.823l-5.152.646-.184.855,1.012.187c.661.158.792.4.648,1.055l-1.66,7.8c-.436,2.018.236,2.968,1.818,2.968a4.66,4.66,0,0,0,3.3-1.345l.2-.936a2.492,2.492,0,0,1-1.544.553c-.619,0-.844-.434-.684-1.2Z",
    transform: "translate(-2.875 -3.955)",
    fill: "#329bc9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M20.25,10.125A2.25,2.25,0,1,1,18,7.875,2.25,2.25,0,0,1,20.25,10.125Z",
    transform: "translate(-3 -1.5)",
    fill: "#329bc9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.a11c24d137db6ef176356ce164d06e99.svg";
export { ForwardRef as ReactComponent };